<template>
  <div class="quickview" :class="{'has-inner-scroll': innerScroll}">
    <div class="quickview__header">
      <div class="quickview__header-title">
        <h1>{{ title }}</h1>
        <p class="quickview__patient-name">{{ subtitle }}</p>
      </div>
      <div class="is-flex">
        <slot name="header-buttons"></slot>
        <div class="quickview__close-button" @click="$emit('close')" data-cy="cm-sidebar-close">
          <i class="mdi mdi-close" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="quickview__content">
      <div class="quickview__widgets">
        <div class="nav-buttons" v-if="$slots['nav-buttons']">
          <slot name="nav-buttons"></slot>
        </div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CMSidebar",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false },
    innerScroll: {type: Boolean, default: false }
  }

}
</script>

<style scoped lang="scss">
.quickview {
  width: var(--quickview-width);
  display: flex;
  height: 100%;
  flex-direction: column;
  border-radius: 6px;
  background: #d4e4ff;
}
.quickview__header {
  display: flex;
  justify-content: space-between;
  padding: 14px 20px 11px;
  border-bottom: 1px solid $background-level-0;
  background: white;
  border-radius: 8px 8px 0 0;
  background: $primary;
  color: #fff;
  align-items: center;
}
.quickview__header-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  h1 {
    font-weight: 500;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    font-size: 13px;
  }
}
.quickview__close-button {
  font-size: 21px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.quickview__content {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}
.quickview__widgets {
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
  > div {
    margin-bottom: 30px;
  }
  :deep(.patient-events, .form-submission-card .monitoring-card__content > div) {
    max-height: 200px;
    overflow-y: auto !important;
  }

}
.quickview__patient-name {
  font-size: 14px;
}
.video-visit-btn {
  margin-right: 15px;
  i {
    font-size: 16px;
  }
}
.events-modal {
  margin-bottom: 0 !important;
}
.app.is-fullscreen-mode .quickview {
  height: calc(100vh - 168px)
}
.quickview.has-inner-scroll {
  .quickview__content {
    overflow: hidden;
  }
  .quickview__widgets {
    height: 100%;
  }
}
.nav-buttons {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px !important;
  :deep(button) {
    transition: all 0.1s linear;
    flex: 1 1;
  }
}
</style>
